export const getEnvRaw = () => {
  if (process == undefined) return {};
  if (process.env == undefined) return {};
  return {
    SPEED_MASTER_URL: process.env.SPEED_MASTER_URL,
  };
};
